




























































































































































































import DkyTabs from './components/tabs.vue'
import {
  apiGroupBuyingOrderGetUserOrders,
  apiGroupBuyingOrderPay,
  apiOrderMerchantStoreList,
  apiOrderOrderStatisticsCount,
  apiPageConfigUserBaseInfo,
} from '@/api'
import { computed } from '@vue/composition-api'
import { dcb } from '@dcb/jssdk'
import { defineClassComponent, useApi } from '@/hooks'
import { globalModel } from '@/model'
import { GroupBuyingUtils } from '../group_buying/utils'
import { navigateTo } from '@/router'
import { prepareData, submit, Track } from '@/utils'
import { wait } from 'vtils'

export default defineClassComponent(
  {
    components: {
      DkyTabs,
    },
  },
  () =>
    class {
      constructor() {
        Track.useMark(() => ({
          page: '我的',
        }))
      }

      // 页面数据
      pageData = useApi(
        () =>
          prepareData({
            // 用户数据
            user: apiPageConfigUserBaseInfo(),
            // 统计数据
            stat: apiOrderOrderStatisticsCount({}),
            // 拼团订单数据
            groupBuyingOrder: apiGroupBuyingOrderGetUserOrders(),
            // 是否有店铺
            hasMart: apiOrderMerchantStoreList().then(res => res.length > 0),
          }),
        {
          refreshOnActivated: true,
        },
      )

      // 用户数据
      userData = computed(() => this.pageData.data.user)

      // 统计数据
      statData = computed(() => this.pageData.data.stat)

      // 拼团订单数据
      groupBuyingOrderData = computed(
        () => this.pageData.data.groupBuyingOrder,
      )

      // 是否有店铺
      hasMart = computed(() => this.pageData.data.hasMart)

      // 点击商家中心
      handleMerchantClick = () => {
        navigateTo('ManageIndex')
      }

      // 点击我的订单
      handleOrderClick = (index: number) => {
        navigateTo('OrderIndex', {
          active: index,
        })
      }

      // 点击我的配送-全部订单
      handleInstantDeliveryMoreClick = () => {
        navigateTo('InstantDeliveryOrderIndex')
      }

      // 点击我的拼团-全部订单
      handleGroupBuyingMoreClick = () => {
        navigateTo('GroupBuyingOrderIndex')
      }

      // 点击消费券包
      handleCouponClick = () => {
        dcb.navigateTo({
          url: process.env.VUE_APP_COUPON_PACKAGE_URL!,
        })
      }

      // 点击其他
      handleOthersClick = (
        label: '我的地址' | '优惠券包' | '我的收藏' | '我的足迹' | '我的盒柜',
      ) => {
        if (label === '我的地址') {
          return navigateTo('AddressIndex', {
            isView: true,
          })
        }
        if (label === '优惠券包') {
          return dcb.openCouponCenter()
        }
        navigateTo(
          label === '我的收藏'
            ? 'UserFavorite'
            : label === '我的足迹'
            ? 'UserHistory'
            : label === '我的盒柜'
            ? 'BoxOrderList'
            : 'HomeIndex',
        )
      }

      // 点击帮助
      handleHelpClick = (label: '批量采购' | '商家入驻' | '联系客服') => {
        if (label === '批量采购') {
          return dcb.navigateTo({
            url: 'https://wap.gogpay.cn/8aaa86d67aebce0f017ccfebfcab0041',
          })
        }
        if (label === '商家入驻') {
          return dcb.navigateTo({
            url: 'https://wap.gogpay.cn/8aaa86d67aebce0f017ccfeba4d50040',
          })
        }
        if (label === '联系客服') {
          return dcb.makeCustomerServicePhoneCall()
        }
      }

      // 点击拼团邀请
      handleGroupBuyingInviteClick = (
        // eslint-disable-next-line no-undef
        item: (typeof this)['groupBuyingOrderData']['value'][0],
      ) => {
        GroupBuyingUtils.share({
          goodsName: item.commodityName!,
          goodsPrice: item.unitPrice!,
          goodsCover: item.commodityPic!,
          groupOrderId: item.groupOrderId!,
          remainingCount: item.grouped ? 0 : item.differCount!,
        })
      }

      // 点击拼团支付
      handleGroupBuyingPayClick = (
        // eslint-disable-next-line no-undef
        item: (typeof this)['groupBuyingOrderData']['value'][0],
      ) => {
        submit(async $ => {
          await $.start()
          const payData = await apiGroupBuyingOrderPay({
            orderId: item.orderId!,
            payType: globalModel.state.payType as any,
            openId: globalModel.state.openid,
          })
          await dcb.requestPayment({
            provider: 'native',
            showNativeResultPage: false,
            params: payData,
          })
          await $.success('支付成功')
          navigateTo('GroupBuyingOrderIndex')
        })
      }

      // 倒计时结束
      handleCountdownEnd = () => {
        wait(2000).then(() => this.pageData.refresh())
      }
    },
)
